import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const membershipBindingReadSnapshotResponseSchema = jsonObject
export const membershipBindingReadCanPerformResponseSchema = jsonObject
export type MembershipBindingReadSnapshotResponse = z.infer<typeof membershipBindingReadSnapshotResponseSchema>
export type MembershipBindingReadCanPerformResponse = z.infer<typeof membershipBindingReadCanPerformResponseSchema>
